var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("app-header"),
      _vm._v(" "),
      _vm.isSignedIn
        ? _c(
            "div",
            { staticClass: "d-flex flex-row mt-5" },
            [
              _vm.isAdmin
                ? _c("admin-sidebar", { staticClass: "px-2 pt-4" })
                : _c("app-sidebar", { staticClass: "px-2 pt-4" }),
              _vm._v(" "),
              _c(
                "main",
                [
                  _c(
                    "b-container",
                    { staticClass: "bg-light", attrs: { fluid: "" } },
                    [
                      _c(
                        "b-row",
                        { staticClass: "content" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "px-4 py-5" },
                            [_c("router-view")],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "px-0" },
                            [_c("terms-footer")],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isSignedIn
        ? _c(
            "b-container",
            { staticClass: "mt-5", attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "content" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "py-5 mx-auto",
                      attrs: { md: "6", lg: "5" }
                    },
                    [_c("router-view")],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [_c("b-col", { staticClass: "px-0" }, [_c("terms-footer")], 1)],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = Ty93
// module chunks = 1